import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Button } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import isUrl from 'is-url';

var TextLinkHoverMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(TextLinkHoverMenu, _React$Component);

  var _super = _createSuper(TextLinkHoverMenu);

  function TextLinkHoverMenu(props) {
    var _this;

    _classCallCheck(this, TextLinkHoverMenu);

    _this = _super.call(this, props);

    _this.saveRef = function (ref) {
      _this.refDom = ref;
    };

    _this.getLinkUrl = function () {
      var linkNode = _this.props.editorUtils.getCurrentLinkNode();

      if (linkNode) {
        _this.linkUrl = linkNode.data.href;
      }
    };

    _this.setMenuPosition = function () {
      if (window.getSelection().anchorOffset !== 0 && window.getSelection().focusOffset !== 0) {
        var native = window.getSelection();
        var range = native.getRangeAt(0);
        var rect = range.getBoundingClientRect();

        if (navigator.userAgent.indexOf('Chrome') < 0 && navigator.userAgent.indexOf('Safari') > 0) {
          if (range.collapsed && rect.top === 0 && rect.height === 0) {
            if (range.startOffset === 0) {
              range.setEnd(range.endContainer, 1);
            } else {
              range.setStart(range.startContainer, range.startOffset - 1);
            }

            rect = range.getBoundingClientRect();

            if (rect.top === 0 && rect.height === 0) {
              if (range.getClientRects().length) {
                rect = range.getClientRects()[0];
              }
            }
          }
        }

        var style = _this.refDom.style;
        style.zIndex = '1050';
        style.top = "".concat(rect.top - 45, "px");
        var left = parseInt(rect.x - 125);

        if (left < 0) {
          style.left = '0px';
        } else if (left + 250 > document.body.clientWidth) {
          style.left = "".concat(document.body.clientWidth - 250, "px");
        } else {
          style.left = "".concat(rect.x - 125, "px");
        }
      }
    };

    _this.componentDidMount = function () {
      requestAnimationFrame(function () {
        _this.setMenuPosition();
      });
    };

    _this.componentWillUnmount = function () {
      _this.refDom = null;
    };

    _this.componentWillMount = function () {
      _this.getLinkUrl();
    };

    _this.onLinkClick = function (e) {
      if (!isUrl(_this.linkUrl)) {
        e.preventDefault();
      }
    };

    _this.linkUrl = '';
    return _this;
  }

  _createClass(TextLinkHoverMenu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setMenuPosition();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      this.getLinkUrl();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var editorUtils = this.props.editorUtils;
      return /*#__PURE__*/React.createElement("div", {
        className: "seafile-ed-hovermenu",
        ref: function ref(_ref) {
          return _this2.refDom = _ref;
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: this.linkUrl,
        onClick: this.onLinkClick,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "seafile-ed-hovermenu-link"
      }, this.linkUrl), /*#__PURE__*/React.createElement(Button, {
        color: "",
        className: "seafile-ed-hovermenu-btn",
        onClick: editorUtils.unwrapLink
      }, /*#__PURE__*/React.createElement("i", {
        className: "iconfont icon-delete"
      })), /*#__PURE__*/React.createElement(Button, {
        color: "",
        className: "seafile-ed-hovermenu-btn",
        onClick: this.props.onToggleLinkDialog
      }, /*#__PURE__*/React.createElement("i", {
        className: "iconfont icon-edit"
      })), /*#__PURE__*/React.createElement("span", {
        className: "seafile-ed-hovermenu-triangle"
      }));
    }
  }]);

  return TextLinkHoverMenu;
}(React.Component);

export default withTranslation('seafile-editor')(TextLinkHoverMenu);